var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Home"}},[_c('Topimage',{staticClass:"topbkColor"}),_c('WhatsPinPos',{staticClass:"WhatspinposBk"}),_c('HowPinPosWorks',{staticClass:"HowPinPosWorksBK"}),_c('TrustedSection',{staticClass:"TrustedBK"}),_c('div',{attrs:{"id":"contactButton"}},[_c('Contact',{staticClass:"ContactBK"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }